import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import Logo from "./Logo";
import TopBar from "./TopBar";

const NAV = [
  { label: "Accueil", to: "/" },
  { label: "À propos", to: "/a-propos" },
  { label: "Services", to: "/services" },
  { label: "Formations", to: "/formations" },
  { label: "Nouvelles", to: "/nouvelles" },
  { label: "Nous joindre", to: "/nous-joindre" }
];

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, setOpen]);

  const isActive = (to) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50">
      <TopBar />
      <div className="w-full bg-white shadow-sm border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-[78px] flex items-center justify-between">
          <Logo />

          <nav className="hidden lg:flex items-center gap-7">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`relative whitespace-nowrap text-[13px] font-semibold tracking-wide uppercase transition-colors duration-200 ${
                  isActive(item.to) ? "text-[#2f80c4]" : "text-[#15324f] hover:text-[#2f80c4]"
                }`}
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {item.label}
                <span
                  className={`absolute -bottom-1.5 left-0 h-[2px] bg-[#2f80c4] transition-all duration-300 ${
                    isActive(item.to) ? "w-full" : "w-0"
                  }`}
                />
              </Link>
            ))}
          </nav>

          <Link
            to="/nous-joindre"
            className="hidden xl:inline-flex items-center px-5 py-2.5 bg-[#15324f] text-white text-[12px] font-semibold tracking-wide uppercase rounded hover:bg-[#2f80c4] transition-colors duration-300 whitespace-nowrap"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Consultation
          </Link>

          <div className="lg:hidden">
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger aria-label="Menu" className="p-2 text-[#15324f]">
                <Menu size={26} />
              </SheetTrigger>
              <SheetContent side="right" className="w-[280px] bg-white">
                <div className="mt-8 flex flex-col gap-1">
                  {NAV.map((item) => (
                    <Link
                      key={item.to}
                      to={item.to}
                      className={`py-3 px-2 text-[15px] font-semibold uppercase tracking-wide border-b border-slate-100 ${
                        isActive(item.to) ? "text-[#2f80c4]" : "text-[#15324f]"
                      }`}
                      style={{ fontFamily: "'Montserrat', sans-serif" }}
                    >
                      {item.label}
                    </Link>
                  ))}
                  <Link
                    to="/nous-joindre"
                    className="mt-4 text-center px-5 py-3 bg-[#15324f] text-white text-[13px] font-semibold tracking-wide uppercase rounded"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    Demander une consultation
                  </Link>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
